export default function({ store, next, router }) {
  if (!store.state.auth.token) {
    //console.log('not_logged_in')
    router.replace({
      name: "login-tenants",
    });
  }
  next();
}
